import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StripHtmlHelper {
  stripHtml(str: string) {
    return str.replaceAll(/<\/?[^>]+(>|$)/gi, '');
  }
  stripHtmlAndNormalize(str: string): string {
    if (!str) return '';
    let cleaned = str.replace(
      /<\/(p|div|h[1-6]|li|td|th)>\s*<(p|div|h[1-6]|li|td|th)[^>]*>/gi,
      ' '
    );
    cleaned = cleaned.replace(/<\/?[^>]+(>|$)/gi, '');

    return cleaned;
  }
}
